export const config = {
    baseUrl: "https://voice.mave.work"
    // baseUrl: 'http://localhost:3000'
}
